import { useRef, useState } from "react";
import Footer from "../../../components/footer";
import { handleMessageError } from "../../../components/toast";
import TableMain from "./table";
import HeaderReport from "../../../components/header/report";
import ModalMain from "../../../components/modal";
import { ToastContainer } from "react-toastify";
import HeaderListFilter from "../../../components/header/report-filter";
import { SlicedObject } from "../../../util/libObject";
import ListTotalReport from "../../../components/list/list-total";
import ReportModalContent from "../../../components/report/ReportModalContent";

// usado para trazer o resultado completo da pesquisa de uma vez, sem paginação, ao gerar o relatório
const REPORT_FETCH_PER_PAGE = 100000;

const MainReportMatrix = ({ options, fetch, fetchSum, FormFilter, FormAux, onCustomAction }) => {
	const { title, subTitle, tableColumns, identReport, reportColumns, customActionLabel } = options;
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingReport, setIsLoadingReport] = useState(false);
	const [isLoadingCustomAction, setIsLoadingCustomAction] = useState(false);

	const [selectData, setSelectData] = useState({});

	//Controle de filtros e dados
	const [fetchData, setFetchData] = useState([]);
	const [reportData, setReportData] = useState([]); //resultado completo da pesquisa (sem paginação) usado no modal de relatório
	const [listDataTotal, setListDataTotal] = useState({}); //informações da tabela retornada do banco
	const [filterListData, setFilterListData] = useState({}); //Preparado para mostrar na tela os filtros
	const [filterData, setFilterData] = useState({});
	const [bodySearch, setBodySearch] = useState({}); //os dados vindo do submit como é e usado para fazer a pesquisa e recarregar o filtro

	//Controle de paginação
	const [page, setPage] = useState(1);
	const [totalPage, setTotalPage] = useState(0);
	const [showSumButton, setShowSumButton] = useState(false);
	const [hasSummed, setHasSummed] = useState(false);
	const currentPage = useRef(0);

	const firstFetch = async (filterFormatedForList, filterData) => {
		const body = await SlicedObject(filterData);

		const response = await fetch(body, 1);

		const data = response.data || [];

		const recordCount = data.length;

		if (recordCount < 15) {
			setTotalPage(1);
		} else {
			setTotalPage(0);
			currentPage.current = 1;
		}

		setFetchData(data); //dados da pesquisa no banco

		setFilterListData(filterFormatedForList); //filtros formatados para mostrar na tela os filtros
		setFilterData(filterData); //para atualizar o filtro de pesquisa
		setBodySearch(body); //filtro para pesquisar no banco de dados
		setHasSummed(false);
		setListDataTotal({}); // Não mostra totais até clicar em Soma
		setShowSumButton(Boolean(fetchSum && options.hasSum && data.length > 0));

		setPage(1);
	};

	const handleListDataTotal = async (data) => {
		let list = {};

		try {
			if (options.listDataTotal && data?.length > 0) {
				options.listDataTotal.forEach((item) => {
					if (data[0][item.key] !== undefined) {
						list[item.key] = {
							label: item.label || item.key, // Usa item.label se existir, senão usa a key
							value: data[0][item.key],
							format: item.format || "", // Usa item.format se existir, senão usa "default"
						};
					}
				});
			}
			setListDataTotal(list);
		} catch (error) {
			setListDataTotal({});
		}
	};

	const nextFetch = async (newPage) => {
		try {
			setIsLoading(true);

			if (totalPage > 0) return;

			// const body = filterData;

			const response = await fetch(bodySearch, newPage);

			const data = response.data || [];

			if (data.length > 0) {
				setFetchData((prevDate) => [...prevDate, ...data]);
			}

			if (data.length === 0 || data.length < 15) {
				setTotalPage(currentPage.current + 1);
			} else {
				currentPage.current++;
			}
		} catch (error) {
			handleMessageError(error.message);
		} finally {
			setIsLoading(false);
		}
	};

	const callBackSubmitModalFilter = async (filterFormatedForList, filterData) => {
		try {
			setIsLoading(true);

			await firstFetch(filterFormatedForList, filterData);

			handleCloseModalFilter();
		} catch (error) {
			handleMessageError(error.message);
		} finally {
			setIsLoading(false);
		}
	};

	const handleSumClick = async () => {
		if (!fetchSum || !bodySearch) return;

		try {
			setIsLoading(true);
			const response = await fetchSum(bodySearch);
			const payload = response?.data || response;
			const result = Array.isArray(payload) ? payload[0] : payload;
			const sumResult = {};

			options.listDataTotal?.forEach((item) => {
				if (result?.[item.key] !== undefined) {
					sumResult[item.key] = {
						label: item.label || item.key,
						value: result[item.key],
						format: item.format || "",
					};
				}
			});

			setListDataTotal(sumResult);
			setShowSumButton(false);
			setHasSummed(true);
		} catch (error) {
			handleMessageError(error.message);
		} finally {
			setIsLoading(false);
		}
	};

	const handleOpenMainModal = (e) => {
		e.preventDefault();
		const event = new CustomEvent(options.identFilter);
		window.dispatchEvent(event);
	};

	const handleCloseModalFilter = () => {
		const event = new CustomEvent(options.identFilter);
		window.dispatchEvent(event);
	};

	const handleOpenModalAux = () => {
		setIsOpenModalAux(true);
		const event = new CustomEvent(options.identAux || "aux");
		window.dispatchEvent(event);
	};

	const handleCloseModalAux = () => {
		setIsOpenModalAux(false);
		const event = new CustomEvent(options.identAux || "aux");
		window.dispatchEvent(event);
	};

	const handleOpenModalReport = async () => {
		if (!fetch || !bodySearch) return;

		try {
			setIsLoadingReport(true);
			const response = await fetch(bodySearch, 1, REPORT_FETCH_PER_PAGE);
			setReportData(response?.data || []);

			const event = new CustomEvent(`${identReport}`);
			window.dispatchEvent(event);
		} catch (error) {
			handleMessageError(error.message);
		} finally {
			setIsLoadingReport(false);
		}
	};

	const handleCustomAction = async () => {
		if (!onCustomAction) return;

		try {
			setIsLoadingCustomAction(true);
			const itemsPerPage = 15;
			const startIndex = (page - 1) * itemsPerPage;
			const endIndex = startIndex + itemsPerPage;
			const currentPagedData = fetchData.slice(startIndex, endIndex);

			await onCustomAction(currentPagedData, page, filterListData);
		} catch (error) {
			handleMessageError(error.message);
		} finally {
			setIsLoadingCustomAction(false);
		}
	};

	const [isOpenModalAux, setIsOpenModalAux] = useState(false);

	return (
		<>
			<ToastContainer />
			<header className="flex flex-col bg-white p-2 rounded-sm box-shadow-md">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title={title} subTitle={subTitle} />
					</div>
					<div className="col-span-1 flex justify-end mb-2">
						<div className="flex flex-col gap-1">
							<HeaderListFilter filterData={filterListData} />

							<ListTotalReport listDataTotal={listDataTotal} />
						</div>
					</div>
				</div>

				<div className="col-span-1 flex justify-end items-end">
					<div className="flex gap-2 h-8">
						<button className="btn btn-sm btn-primary w-32" onClick={(e) => handleOpenMainModal(e)}>
							Listar
						</button>{" "}
						{showSumButton && !hasSummed && (
							<button className="btn btn-sm btn-secondary w-32" onClick={handleSumClick}>
								Soma
							</button>
						)}{" "}
						{reportColumns && (
							<button
								className="btn btn-sm btn-danger w-32"
								onClick={handleOpenModalReport}
								disabled={isLoadingReport}
							>
								{isLoadingReport ? "Carregando..." : "Relatório"}
							</button>
						)}
						{onCustomAction && (
							<button
								className="btn btn-sm btn-secondary min-w-[208px] px-4 w-auto"
								onClick={handleCustomAction}
								disabled={isLoadingCustomAction}
							>
								{isLoadingCustomAction 
									? "Gerando..." 
									: customActionLabel 
										? customActionLabel.replace("{page}", page) 
										: "Imprimir"}
							</button>
						)}
					</div>
				</div>
				<div className="border-bottom mt-3"></div>
			</header>

			<main className="flex flex-1 bg-red-200 mt-2">
				<TableMain
					tableColumns={tableColumns}
					searchedData={fetchData}
					isLoading={isLoading}
					nextFetch={nextFetch}
					page={page}
					setPage={setPage}
					totalPage={totalPage}
					currentPage={currentPage}
					setSelectData={setSelectData}
					handleOpenModalAux={handleOpenModalAux}
				/>
			</main>
			<footer>
				<Footer />
			</footer>
			<ModalMain ident={options.identFilter}>
				<FormFilter
					options={options}
					handleSubmitModalFilter={callBackSubmitModalFilter}
					reloadFilter={filterData}
				/>
			</ModalMain>

			{FormAux && (
				<ModalMain ident={options.identAux || "aux"} className="modal-content-form modal-product-resize">
					<FormAux
						isOpen={isOpenModalAux}
						idTable={options.id}
						selectedData={selectData}
						handleClose={handleCloseModalAux}
					/>
				</ModalMain>
			)}

			<ModalMain ident={identReport}>
				<ReportModalContent
					reportColumns={reportColumns}
					data={reportData}
					filters={filterListData}
					title={title}
					headerSubtitle={subTitle}
					defaultFormat="pdf" // ou "csv"
					totals={listDataTotal}
				/>
			</ModalMain>
		</>
	);
};

export default MainReportMatrix;
